/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function PhoneSlash(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M120.8877,108.28271c-.01416-.01562-.02832-.03173-.043-.04736l-31.083-34.19092c-.01611-.01855-.03272-.03613-.04883-.0542l-35.793-39.37207A8.0006,8.0006,0,1,0,42.08008,45.38184L70.03857,76.13623a142.75371,142.75371,0,0,0-43.86279,30.04053,56.07211,56.07211,0,0,0-4.69043,73.87695,16.03254,16.03254,0,0,0,18.55078,4.99707L87.35059,166.125a15.94917,15.94917,0,0,0,9.74609-11.71875l5.90527-29.51172a76.1958,76.1958,0,0,1,9.07422-2.51709l90.00391,99.0044a8.0006,8.0006,0,1,0,11.83984-10.76368Z" />
        <Path d="M229.82422,106.17578a144.20418,144.20418,0,0,0-109.73633-41.96A8.00053,8.00053,0,0,0,114.60547,77.585l94.36035,103.79883a8.0075,8.0075,0,0,0,2.94824,2.04687l4.04883,1.62012a16.03429,16.03429,0,0,0,18.55273-4.99805A56.07343,56.07343,0,0,0,229.82422,106.17578Z" />
      </G>
    </Svg>
  );
}

export default PhoneSlash;
